const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/incidents',
    authenticatedEntryPathAdminExpert: '/app/incidents',
    authenticatedEntryPathStandard: '/app/incidents',
    unAuthenticatedEntryPath: '/add-incident',
    tourPath: '/incidents',
    enableMock: true
}

export default appConfig